export const getStartUrl = "/einvoicing-australia/#create_account"
export const meetingUrl = "https://meetings.hubspot.com/ray-wang/meeting-with-luca-plus"

export const ebookUrl = "https://hubs.ly/H0ww6DV0"